import { render, staticRenderFns } from "./OneDocSubmitted.vue?vue&type=template&id=728de658&scoped=true&"
import script from "./OneDocSubmitted.vue?vue&type=script&lang=js&"
export * from "./OneDocSubmitted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728de658",
  null
  
)

export default component.exports